// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"222":"08c3b0ee","241":"6b51adb0","511":"28bba149","527":"66664f7b","737":"e77f2d88","761":"3746d6d1","799":"4caa9853","842":"ac9d670e","873":"cdd65838"}[chunkId] + ".js";
};